<template>
    <div>
        <div class="toggled-options map-panel">
            <div class="map-panel--routing_options">
                <button @click="handleMapToggle">
                    <md-icon>announcement</md-icon>
                    <md-tooltip class="toggle-tooltip" md-direction="bottom">Try the new map</md-tooltip>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    name: 'MapSwitchButton',
    methods: {
        ...mapMutations({
            saveToggleUseNewMap: 'map/TOGGLE_USE_NEW_MAP'
        }),
        handleMapToggle() {
            this.saveToggleUseNewMap(true);
            this.$router.push({
                path: '/mapview2'
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.md-tooltip-top {
    &.toggle-tooltip {
        // offset for pooper.js
        margin-left: 20px !important;
    }
}
.toggled-options {
    top: 10px;
    right: 200px;
    z-index: 2;
    height: 40px;
    position: absolute;
    background-color: rgba(255, 255, 255, 0.9);
    height: auto;
    display: flex;

    button {
        padding: 10px;
        border: none;
        background: transparent;
        cursor: pointer;
        margin: 0 auto;
    }
}
.map-panel--routing_options {
    position: relative;
    display: flex;
}
</style>
